import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { emailTemplateQueryKeys } from "./emailTemplateQueryKeys";

export function useEmailTemplateCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newEmailTemplate: { [k: string]: any }) =>
      api.emailTemplateApi.create(newEmailTemplate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emailTemplateQueryKeys.all() });
    },
  });
}
